import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { ProductoPrecioCuotasController } from './producto-precio-cuotas.controller';
import { ProductoPrecioCuotasService } from './producto-precio-cuotas.service';

@Module({
  imports: [PrismaModule],
  controllers: [ProductoPrecioCuotasController],
  providers: [ProductoPrecioCuotasService],
  exports: [ProductoPrecioCuotasService],
})
export class ProductoPrecioCuotasModule {}
